<!-- components/RecaptchaBox.vue -->
<template>
  <div class="w-full flex justify-center mt-4">

    <RecaptchaV2 ref="recaptcha"  @widget-id="handleWidgetId"
      @error-callback="handleErrorCallback" @expired-callback="handleExpiredCallback"
      @load-callback="handleLoadCallback" />
  </div>
</template>

<script>

import { RecaptchaV2, useRecaptcha } from "vue3-recaptcha-v2";
const { handleReset } = useRecaptcha();
export default {
  components: { RecaptchaV2 },
  emits: ['verified'],
  data() {
    return {
      token: null,
      widgetId:null
    }
  },
  methods: {
    handleWidgetId(widgetId) {
      this.widgetId = widgetId
    },

    handleLoadCallback(response) {
      this.token = response;
      this.$emit('verified', response);
    },
    handleErrorCallback() {
      this.token = null;
    },

    handleExpiredCallback() {
      this.token = null;
    },
    resetCall() {
      handleReset(this.widgetId);
    }
  }
}
</script>
